import { TextField } from '@material-ui/core';
import { getIn } from 'formik';
import React, { useCallback } from 'react';
import { Hint } from 'v2/components/Shared/Hint';

import type { FieldProps } from 'formik';

interface IProps extends FieldProps {
  placeholder?: string;
  onlyNumbers?: boolean;
  /**
   * defaults to `true`
   */
  replaceSpaceWithComma?: boolean;
}

export const MultipleTextFormField = ({ field, form, replaceSpaceWithComma = true, ...props }: IProps) => {
  const { value, name } = field;

  const errorText = getIn(form.errors, field.name);

  const convertOnlyNumbers = (v: string) => {
    return v.replace(/[^0-9,]/g, '');
  };

  const convertNoSpace = (v: string) => {
    return v.replace(/\s/g, ',');
  };

  const convert = useCallback(
    (v: string) => {
      if (replaceSpaceWithComma) {
        v = convertNoSpace(v);
      }
      if (props.onlyNumbers) {
        v = convertOnlyNumbers(v);
      }
      return v ? v.split(',') : [];
    },
    [props.onlyNumbers, replaceSpaceWithComma]
  );

  const onChangeHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const v = e.target.value;
      const value = convert(v);
      form.setFieldValue(field.name, value);
    },
    [convert, form, field.name]
  );

  const onBlurHandler = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      const v = e.target.value;
      const value = convert(v);
      form.setFieldValue(field.name, value);
    },
    [convert, form, field.name]
  );

  return (
    <Hint inputName={field.name}>
      <TextField
        fullWidth
        placeholder={props.placeholder || 'Separe os valores usando , (vírgula)'}
        helperText={errorText || null}
        error={!!errorText}
        name={name}
        value={value}
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        {...props}
      />
    </Hint>
  );
};
